var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.label || _vm.label === false)?_c('rkm-form-input',{attrs:{"label":_vm.label,"value":_vm.value,"append":_vm.append,"disabled":""}}):_c('rkm-form-input',{attrs:{"value":_vm.value,"append":_vm.append,"disabled":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }